/**
 * `firebase/functions`, with every callable timed (vite.config.ts aliases the
 * import here). Everything else is the real module.
 */
import { httpsCallable as realHttpsCallable } from '@firebase/functions';
import { trackRequest } from './slow-requests';

export * from '@firebase/functions';

export const httpsCallable = ((functionsInstance, name, options) => {
  const callable = realHttpsCallable(functionsInstance, name, options);
  const timed = ((data?: unknown) => trackRequest(callable(data as never))) as typeof callable;
  return Object.assign(timed, { stream: callable.stream });
}) as typeof realHttpsCallable;
